import { Button, useSidebar } from "ksc-portal-common-components/shadcn"

import React from "react"

import { ChevronLeft } from "lucide-react"
import DynamicTitle from "../Navbar/DynamicTitle"
import { SidebarNavigation } from "./SidebarNavigation"
import { SidebarProps } from "../Sidebar/types"

export const SidebarContent = ({
  history,
  sidebarData,
  sourceUrl,
  openSidebar,
  closeSidebar,
}: SidebarProps) => {
  const { toggleSidebar, state } = useSidebar()
  const isCollapsed = state === "collapsed"
  const toggleCollapse = () => {
    if (isCollapsed) {
      openSidebar()
    } else {
      closeSidebar()
    }
    toggleSidebar()
  }
  return (
    <div className="flex h-full w-full flex-col bg-white">
      <div className="flex items-center justify-between pl-8 pt-8 pb-9">
        <DynamicTitle history={history} />
        {!isCollapsed && (
          <Button
            variant="ghost"
            size="icon"
            onClick={toggleCollapse}
            data-testid="sidebar-collapse-toggle"
            className="absolute -right-5 h-10 w-10 rounded-full shadow-sm bg-white border border-gray-200"
          >
            <ChevronLeft className="h-7 w-7" />
          </Button>
        )}
      </div>
      <SidebarNavigation
        sourceUrl={sourceUrl}
        isCollapsed={isCollapsed}
        sidebarData={sidebarData}
      />
    </div>
  )
}

export default SidebarContent
